import { CATEGORY_NAV, GET_CART, PROMOTIONS_QUANTITY, QUANTITY_CHANGED, SET_CART } from "redux/constants/Cart";
import { templateAction } from "./Data";

export const getCart=(payload) => templateAction(GET_CART, payload)
export const setCart=(payload) => templateAction(SET_CART, payload)
export const changeQuantity = (payload) => templateAction(QUANTITY_CHANGED, payload)
export const changePromotionsQuantity = (payload) => templateAction(PROMOTIONS_QUANTITY, payload)

export const setCategoryNavClicked=(payload) => templateAction(CATEGORY_NAV, payload)